import React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    fetchStart,
} from 'react-admin';
import {Paper, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography} from '@material-ui/core';
import Errors from "../legal_entity/Errors";
import errorMessage from "../helper/ErrorMessage";
import {
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl
} from '@mui/material';
import AgentAPI from "./AgentAPI";
import SignedRequest from "./SignedRequest";

const ContractRequestDetailsButton = (prop) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [keyType, setKeyType] = useState('0');
    const [signType, setSignType] = useState('');
    const [ca, setCa] = useState('');
    const [signPath, setSignPath] = useState('');
    const [password2, setPassword2] = useState('');

    const agentUrl = 'https://cipher.kiev.ua/files/pcs/jnlp/pcs-dev-preview.jnlp';
    let keyCallbacks = {
        verify: AgentAPI.verifyKey,
        sign: AgentAPI.signString
    };

    React.useEffect(() => {
        const interval = setInterval(() => {AgentAPI.checkStatus()}, 2000);
        return () => clearInterval(interval);
    });

    const popupAlert = (message) => {
        setAlertOpen(true);
        setAlertText(message);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const popupConfirm = () => {
        setConfirmOpen(true);
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleSave= () => {
        setLoading(true);
        dispatch(fetchStart());
        const signFile = document.getElementById('sign-file');
        const password = document.getElementById('sign-password');
        const gryadaLogin = document.getElementById('gryada-login');
        const gryadaPassword = document.getElementById('gryada-password');
        const body = {};
        const selectedPharmacies = [];

        if (keyType === '0') {
            if (
                signFile.files.length === 0
                || typeof signFile.files[0] === 'undefined'
            ) {
                popupAlert('Вкажіть файл ЕЦП');
                return;
            }

            if (password.value.trim() === '') {
                popupAlert('Вкажіть пароль');
                return;
            }

            // for (let i = 0; i < pharmacies.length; i++) {
            //     if (document.getElementById(pharmacies[i].id).checked) {
            //         selectedPharmacies.push(pharmacies[i].id);
            //     }
            // }

            body.pharmacies = selectedPharmacies;
            body.signType = 'file';

            const reader = new FileReader();
            reader.onloadend = event => {
                body.file = event.target.result;
                body.password = password.value.trim();
                let fileParts = signFile.files[0].name.split('.');
                body.extension = fileParts[fileParts.length - 1];

                sendRequest(body);
            };

            reader.readAsDataURL(signFile.files[0]);
        } else if (keyType === '1') {
            if (ca === '') {
                popupAlert('Вкажіть КНЕДП');
                return;
            }
            if (signType === '') {
                popupAlert('Вкажіть тип ключа');
                return;
            }
            if (signPath === '') {
                popupAlert('Вкажіть шлях до контейнеру');
                return;
            }
            if (password2 === '') {
                popupAlert('Вкажіть пароль');
                return;
            }

            const formData = {
                ca: ca,
                signPath: signPath,
                password2: password2
            };

            keyCallbacks.verify(formData, async (data) => {
                if (!data.keyAgreement?.canBeUsed || !data.signature?.canBeUsed) {
                    popupAlert('Помилка зчитування КЕП');
                    setLoading(false);
                    return;
                }

                await SignedRequest(
                    null,
                    keyCallbacks,
                    formData,
                    process.env.REACT_APP_BASE_ENTRYPOINT + '/contract_request/sign/' + prop.id + '?onlySerialize=1',
                    process.env.REACT_APP_BASE_ENTRYPOINT + '/contract_request/send-sign/' + prop.id,
                    popupAlert,
                    setLoading,
                    true
                );
            });
        } else if (keyType === '2') {
            if (gryadaLogin.value.trim() === '') {
                popupAlert('Вкажіть пароль');
                return;
            }

            if (gryadaPassword.value.trim() === '') {
                popupAlert('Вкажіть пароль');
                return;
            }

            body.signType = 'gryada';
            body.pharmacies = selectedPharmacies;
            body.gryadaLogin = gryadaLogin.value.trim();
            body.gryadaPassword = gryadaPassword.value.trim();

            sendRequest(body);
        }
    };

    const sendRequest = (body) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/octet-stream',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            },
            body: JSON.stringify(body)
        };

        fetch(
            process.env.REACT_APP_BASE_ENTRYPOINT + '/contract_request/sign/' + prop.id,
            requestOptions
        )
            .then((response) => {
                if (response.status >= 400) {
                    return Promise.reject();
                }

                return response.json();
            })
            .then((data) => {
                if (data.success) {
                    popupAlert('Документ підписаний');
                    setConfirmOpen(false);
                } else {
                    errorMessage(data, popupAlert);
                }

            })
            .catch(() => {
                popupAlert('Помилка надсилання запиту');
            });
    };

    const changeKeyType = (event) => {
        setKeyType(event.target.value);
    };

    const changeSignType = (event) => {
        setSignType(event.target.value);

        let list = [];
        let keyData = JSON.parse(localStorage.getItem('keyData'));

        if (event.target?.value && keyData[event.target?.value]) {
            for (let i = 0; i < keyData[event.target.value].length; i++) {
                list[i] = {id: keyData[event.target.value][i], name: keyData[event.target.value][i]}
            }
        }

        localStorage.setItem('keyList', JSON.stringify(list));
    };

    const changeCa = (event) => {
        setCa(event.target.value);
    };

    const changeSignPath = (event) => {
        setSignPath(event.target.value);
    };

    const changePassword = (event) => {
        setPassword2(event.target.value);
    };

    return (
        <div>
            <Button
                variant="contained"
                disabled={false}
                onClick={popupConfirm}
                color="primary"
            >
                Підписати
            </Button>

            <Dialog
                open={confirmOpen}
                onClose={handleConfirmClose}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="confirm-dialog-content">
                        Засвідчуючи даний договір кваліфікованим електронним підписом я розумію,
                        про настання певних прав та обов’язків, зрозумів текст договору.

                        <Paper elevation={3} style={{textAlign: 'left', padding: '10px'}} label="ЕЦП" multiline fullWidth={true}>
                            <div style={{marginBottom: '25px'}}>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        aria-label="gender"
                                        name="controlled-radio-buttons-group"
                                        value={keyType}
                                        onChange={changeKeyType}
                                    >
                                        <FormControlLabel value="0" control={<Radio />} label="Файловий ключ" />
                                        <FormControlLabel value="1" control={<Radio />} label="Апаратний ключ" />
                                        {process.env.REACT_APP_DEMO_MODE === 'off' ? <FormControlLabel value="2" control={<Radio />} label="Гряда-301" /> : null}
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            <div style={ keyType === '0' ? {} : {display: 'none'} }>
                                <div>
                                    <label htmlFor={"sign-file"} style={{display: 'inline-block', width: '100%'}}>ЕЦП<sup>*</sup></label>
                                    <input type="file" id="sign-file"/>
                                </div>
                                <div style={{marginTop: '20px'}}>
                                    <label htmlFor={"sign-password"} style={{display: 'inline-block', width: '100%'}}>Пароль<sup>*</sup></label>
                                    <input type="password" id="sign-password"/>
                                </div>
                            </div>

                            <div style={ keyType === '2' ? {} : {display: 'none'} }>
                                <div style={{marginTop: '20px'}}>
                                    <label htmlFor={"gryada-login"} style={{display: 'inline-block', width: '100%'}}>Логін<sup>*</sup></label>
                                    <input type="text" id="gryada-login"/>
                                </div>
                                <div style={{marginTop: '20px'}}>
                                    <label htmlFor={"gryaga-password"} style={{display: 'inline-block', width: '100%'}}>Пароль<sup>*</sup></label>
                                    <input type="password" id="gryada-password"/>
                                </div>
                            </div>

                            <div style={ keyType === '1' ? {} : {display: 'none'} }>
                                <div style={{align: 'left', width: '100%'}}>
                                    {localStorage.getItem('started') ? null :
                                        <Button
                                            color="primary"
                                            variant="outlined"
                                            style={{clear: 'both', marginBottom: '20px'}}
                                            onClick={() => {window.location = agentUrl;}}
                                        >
                                            Увімкнути агент
                                        </Button>}

                                    {localStorage.getItem('started')
                                        ? <Typography variant="subtitle1" style={{color: '#22aa22'}}>підключено</Typography>
                                        : <Typography variant="subtitle1" style={{marginLeft: '20px'}}>не підключено</Typography>}
                                </div>

                                <div>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">КНЕДП<sup>*</sup></InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="ca"
                                            value={ca}
                                            label="КНЕДП"
                                            onChange={changeCa}
                                        >
                                            <MenuItem value=""></MenuItem>

                                            {
                                                localStorage.getItem('caList') ?
                                                JSON.parse(localStorage.getItem('caList')).map(
                                                    item => { return <MenuItem value={item.id}>{item.name}</MenuItem>; }
                                                )
                                                : null
                                            }
                                        </Select>
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Тип ключа<sup>*</sup></InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="sign-type"
                                            value={signType}
                                            label="Тип ключа"
                                            onChange={changeSignType}
                                        >
                                            <MenuItem value=""></MenuItem>
                                            <MenuItem value="activeTokenPath">PKCS#11 пристрій - активний режим</MenuItem>
                                            <MenuItem value="passiveTokenPath">PKCS#11 пристрій - пасивний режим</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Шлях до контейнеру<sup>*</sup></InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="sign-path"
                                            value={signPath}
                                            label="Шлях до контейнеру"
                                            onChange={changeSignPath}
                                        >
                                            <MenuItem value=""></MenuItem>

                                            {
                                                localStorage.getItem('keyList') ?
                                                    JSON.parse(localStorage.getItem('keyList')).map(
                                                        item => {return <MenuItem value={item.id}>{item.name}</MenuItem>;}
                                                    )
                                                    : null
                                            }
                                        </Select>
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="password2"
                                            label="Пароль*"
                                            defaultValue={password2}
                                            type="password"
                                            onChange={changePassword}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        </Paper>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSave} variant="contained" color="primary">Добре</Button>
                    <Button onClick={handleConfirmClose} variant="contained">Відхилити</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={alertOpen}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-content">
                        {alertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAlertClose} variant="contained" color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ContractRequestDetailsButton;